// extracted by mini-css-extract-plugin
export var brand = "product-details-module--brand--43d78";
export var detailsWrapper = "product-details-module--detailsWrapper--6a646";
export var imageLink = "product-details-module--imageLink--13e1c";
export var imageSource = "product-details-module--imageSource--a5cf1";
export var imageWrapper = "product-details-module--imageWrapper--c72ec";
export var price = "product-details-module--price--b1184";
export var priceFormat = "product-details-module--priceFormat--e7d28";
export var priceWrapper = "product-details-module--priceWrapper--0788d";
export var productDetailsWrapper = "product-details-module--productDetailsWrapper--43333";
export var productTitleTwoline = "product-details-module--productTitleTwoline--37962";
export var ratingWrapper = "product-details-module--ratingWrapper--b08d0";
export var savePrice = "product-details-module--savePrice--59c8b";
export var titleWrapper = "product-details-module--titleWrapper--7d1ef";
export var uStrike = "product-details-module--uStrike--94684";
export var wasPrice = "product-details-module--wasPrice--8ad7b";